PlannedGenerator = require './planned_generator.coffee'

class SaveTransaction
  constructor: (transaction, mode, user, change_future_trs = false) ->
    @tr                         = transaction
    @transaction                = transaction
    @mode                       = mode
    @user                       = user
    @future_common_transactions = null
    @change_future_trs          = change_future_trs
  run: ->
    # Чтобы все категории выглядели единообразно - 'base / sub'.
    @tr.category = (@tr.category || '').split('/').map((cat) -> cat.trim()).join(' / ')
    amount = @tr.descriptionSum()
    amount = amount * -1 if @tr.isExpense()
    @tr.currency = @tr.accountCurrency(@user)

    if @mode == 'plan'
      @tr.type = 'planned'
      if @tr.isTransfer()
        if @tr._transfer_from_amount
          @tr.plan_amount = @tr._transfer_from_amount
      else
        @tr.plan_amount = amount
      @tr.real_amount = null
      @tr.common_id ||= uuidV4()
      @tr.omitPrivateParams()
      @planned_generator = new PlannedGenerator(@tr, @user, @change_future_trs)

    if @mode == 'enter'
      if @tr.isTransfer()
        if @tr._transfer_from_amount
          @tr.real_amount = @tr._transfer_from_amount
      else
        @tr.real_amount = amount

    @tr.omitPrivateParams()
    HM_API.save_transaction(@tr, @planned_generator)

module.exports = SaveTransaction
